var StackedVerticalBarModule = /** @class */ (function () {
    function StackedVerticalBarModule() {
    }
    return StackedVerticalBarModule;
}());
export { StackedVerticalBarModule };
